<template>

  <div class="container mt-4 mb-5">
    <div class="crema main-color-text border-radius-15 banner-eclipse">

      <div class="text-center p-4 p-lg-5">

        <div class="font-size-14 font-600 text-uppercase mb-3 banner-kicker">
          {{ i18n.eclipse.kicker }}
        </div>

        <h2 class="title-font font-200 mb-2 banner-titulo">
          {{ i18n.eclipse.titulo }}
        </h2>

        <h3 class="title-font font-200 mb-4 banner-subtitulo">
          {{ i18n.eclipse.subtitulo }}
        </h3>

        <div class="linea-roja-corta m-auto mb-4"></div>

        <div class="center-align mb-4">
          <a :href="bookingUrl"
             target="_blank"
             rel="noopener"
             class="button main-color crema-text text-decoration-none title-font font-200 banner-boton">
            {{ i18n.buttons.reservar }}
          </a>
        </div>

        <div class="font-size-16 font-500 banner-hashtag">
          {{ i18n.eclipse.hashtag }}
        </div>

      </div>
    </div>
  </div>

</template>

<script>

import {getI18n} from "../locales/locales";

export default {

  name: 'BannerEclipse',

  computed: {
    i18n() {
      return getI18n();
    }
  },

  data() {
    return {
      bookingUrl: 'https://bookings.sethotels.com/es/bookcore/availability/packs/stsnt/?pid=16731&show=1&fe=2026-08-12&fs=2026-08-12%3Fpartner%3D14448&utm_source=GUESTPRO&utm_medium=NEWSLETTER&utm_campaign=PRE-VENTA+ECLIPSE+PUNTA+NEGRA&utm_id=PRE-VENTA+ECLIPSE+PUNTA+NEGRA'
    };
  },
}

</script>

<style scoped>

/* El body ya es crema, así que el borde es lo que delimita el banner */
.banner-eclipse {
  border: 2px solid #9f3944;
}

.linea-roja-corta {
  width: 150px;
  border-bottom: 3px solid #9f3944;
}

.banner-kicker {
  letter-spacing: 3px;
  opacity: 0.75;
}

.banner-titulo {
  font-size: clamp(36px, 6.5vw, 54px);
  line-height: 1.1;
}

.banner-subtitulo {
  font-size: clamp(28px, 5vw, 42px);
  line-height: 1.1;
}

.banner-hashtag {
  letter-spacing: 1px;
  opacity: 0.75;
}

.banner-boton {
  transition: transform 0.25s, box-shadow 0.25s;
}

.banner-boton:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(159, 57, 68, 0.3);
}

</style>
